import React, { CSSProperties, ReactNode } from "react"
import {
  copyright,
  footer,
  footerGrid,
  footerLink,
  linkTitle,
  rescapeInfo,
  socialLinks,
} from "./footer.css"

type Props = {
  href: string
  title: string
  icon?: ReactNode
  style?: CSSProperties
}

export const FLink = ({ href, title, icon, style }: Props) => {
  let STYLE = style || {}
  if (icon) STYLE = { ...STYLE, alignItems: "center" }

  return (
    <a href={href} className={footerLink} style={STYLE}>
      {!!icon && icon}
      {title}
    </a>
  )
}

const Footer = ({ showLinks = true }) => {
  return (
    <>
      <div className={footer}>
        <div className={footerGrid}>
          <div className={rescapeInfo}>
            <p className={copyright}>© Rescapeai 2024</p>
            <a href="mailto:contact@rescapeai.com">contact@rescapeai.com</a>
          </div>
          <div className={socialLinks}>
            <FLink
              href="https://www.instagram.com/rescapeai/"
              title="Instagram"
              icon={<InstagramICO />}
            />
            <FLink
              href="https://www.tiktok.com/@rescapeai"
              title="TikTok"
              icon={<TikTokICO />}
            />
          </div>
          {showLinks && (
            <>
              <p className={linkTitle}>Rescape AI Blog and Design Guide</p>
              <FLink
                href="/articles"
                title="Blog Articles"
                style={{ lineHeight: "1.5em", fontSize: ".9em" }}
              />
              <FLink
                href="/garden-design-guide"
                title="Rescape's Garden Design Guide"
                style={{ lineHeight: "1.5em", fontSize: ".9em" }}
              />
            </>
          )}
        </div>
      </div>
    </>
  )
}

function InstagramICO() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      height="1rem"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ marginRight: ".65rem" }}
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  )
}

function TikTokICO() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      width="1rem"
      height="1rem"
      fill="currentColor"
      style={{ marginRight: ".65rem" }}
      viewBox="0 0 449.45 515.38"
    >
      <path
        fillRule="nonzero"
        d="M382.31 103.3c-27.76-18.1-47.79-47.07-54.04-80.82-1.35-7.29-2.1-14.8-2.1-22.48h-88.6l-.15 355.09c-1.48 39.77-34.21 71.68-74.33 71.68-12.47 0-24.21-3.11-34.55-8.56-23.71-12.47-39.94-37.32-39.94-65.91 0-41.07 33.42-74.49 74.48-74.49 7.67 0 15.02 1.27 21.97 3.44V190.8c-7.2-.99-14.51-1.59-21.97-1.59C73.16 189.21 0 262.36 0 352.3c0 55.17 27.56 104 69.63 133.52 26.48 18.61 58.71 29.56 93.46 29.56 89.93 0 163.08-73.16 163.08-163.08V172.23c34.75 24.94 77.33 39.64 123.28 39.64v-88.61c-24.75 0-47.8-7.35-67.14-19.96z"
      />
    </svg>
  )
}

export default Footer
